import Pill from './Pill.jsx';

export default Pill;
